<div class="bloco-icone">
  <div class="icone mr-2" *ngIf="icone">
    <i [class]="icone"></i>
  </div>
  <div class="detalhes">
    <span class="titulo">{{titulo}}</span><br />
    <span class="descricao">{{descricao}}</span>
  </div>
</div>

